import React from 'react'
import { useTranslation } from 'react-i18next';
import { getSchoolYear } from '../../../util/validation';
import Dropdown from '../../../../Global/Dropdown';
import { useDispatch, useSelector } from 'react-redux';
import teacherActions from '../../../state/teacher/actions'
import { getWeeksInRange, isDateInRange } from '../../../util/datetime';
import moment from 'moment';
import cloneDeep from 'lodash.clonedeep';

export default function UsageWindowSelect(props) {
  const { isDisabled } = props;

  const {t, i18n} = useTranslation("reports_sidebar");

  const teacherReduxState = useSelector(state => state.reports.teacher)

  const dispatch = useDispatch();
  const setTeacherReduxState = update => dispatch(teacherActions.setState(update));

  const handleChange = (selection) => {
    setTeacherReduxState({usageWindow: selection})
  };

  const usageWindowOptions = getUsageWindowOptions();
  
  const translateOptionLabel = (option) => {
    const {value, isThisWeek, isLastWeek} = option;
    if (value === "school_year") option.label = t("school_year");
    else {
      const {labelStart, labelEnd} = getDateLabelsForUsageWindow(option, i18n);
      if (isThisWeek) option.label = t("this_week", {labelStart, labelEnd});
      else if (isLastWeek) option.label = t("last_week", {labelStart, labelEnd});
      else option.label = t("usage_week", {labelStart, labelEnd});
    }
  }
  
  const options = cloneDeep(usageWindowOptions);
  options.forEach(translateOptionLabel)

  return (
    <Dropdown
      options={options}
      value={teacherReduxState.usageWindow}
      onChange={handleChange}
      isDisabled={isDisabled}
    />
  )
}

export function getUsageWindowOptions() {
  const schoolYear = getSchoolYear();

  const options = [{
    value: "school_year",
    startDate: schoolYear.startDate.toString(),
    endDate: schoolYear.endDate.toString(),
  }];


  const weeksInRange = getWeeksInRange(schoolYear.startDate, schoolYear.endDate).reverse();

  for (const week of weeksInRange) {
    const {startDate, endDate} = week;
    if (startDate >= new Date()) continue;

    const labelStart = moment(startDate).format("MMM D");
    const labelEnd = moment(endDate).format("MMM D");
    let label = `${labelStart} - ${labelEnd}`

    const thisWeek = new Date();
    const lastWeek = moment().subtract(7, 'days').toDate();

    if (isDateInRange(thisWeek, startDate, endDate)) label = `This Week (${label})`
    if (isDateInRange(lastWeek, startDate, endDate)) label = `Last Week (${label})`

    options.push({
      value: `week_${week.startDate.toISOString().slice(0, 10)}`,
      startDate: startDate.toString(),
      endDate: endDate.toString(),
      isThisWeek: isDateInRange(thisWeek, startDate, endDate),
      isLastWeek: isDateInRange(lastWeek, startDate, endDate)
    })
  }

  return options;
}

export function getDateLabelsForUsageWindow(option, i18n) {
  moment.locale(i18n.language);
  const {startDate, endDate} = option;
  const dateFormat = i18n.language === 'en' ? "MMM D" : "D [de] MMM";
  const labelStart = moment(startDate).format(dateFormat);
  const labelEnd = moment(endDate).format(dateFormat);
  return {labelStart, labelEnd}
}